import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "controller-wrapper d-flex brg-input-section"
};
const _hoisted_2 = { class: "d-flex justify-center align-center" };
const _hoisted_3 = { class: "body2-text" };
const _hoisted_4 = { class: "d-flex justify-center align-center" };
const _hoisted_5 = { class: "body2-text" };
const _hoisted_6 = { class: "button-text" };
const _hoisted_7 = { class: "d-flex justify-center align-center" };
const _hoisted_8 = { class: "body2-text" };
const _hoisted_9 = { class: "button-text" };
import { computed, ref, onMounted, } from 'vue';
import InputRow from '@/components/Form/InputRow.vue';
import { initAutoLc } from '@/locales/ko/views/user_permission_setting_dialog';
import vuexStore from '@/vuex-store';
import hubStorage from '@/helpers/hubStorage';
import { UserPermissionSettingVM } from '@/view-model/user-management/UserPermissionSettingVM';
import { i18n } from '@/locales';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
const COPIED_PERMISSION_INFO = 'COPIED_PERMISSION_INFO';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserPermissionSettingDialogController',
    setup(__props) {
        const lc = initAutoLc('');
        const locale = {
            userName: lc('controller.user_name'),
            userLevel: lc('controller.user_level'),
            copyForm: lc('controller.copy_form'),
            pasteForm: lc('controller.paste_form'),
            copiedUserId: lc('controller.copied_user_id'),
            submit: lc('controller.submit'),
        };
        const userInfo = computed(() => vuexStore.state.userPermissionSettingDialog.dialogDetail?.userInfo);
        const getterTargetUserId = computed(() => vuexStore.getters['userPermissionSettingDialog/getterTargetUserId']);
        const userPermissionList = computed(() => vuexStore.state.userPermissionSettingDialog.userPermissionList);
        const userPermissionListAndIdData = computed(() => ({
            list: userPermissionList.value,
            id: getterTargetUserId.value,
        }));
        /** 현재 복사 된 사용자 권한 목록 */
        const currentCopiedPermissionList = ref([]);
        /** 현재 복사 된 사용자 권한 목록 주인 Id */
        const currentCopiedPermissionUserId = ref('');
        /** 복사 가능 여부 (복사값이 있는지) */
        const isPasteDisabled = computed(() => !currentCopiedPermissionUserId.value);
        /** 세션 스토리지에 상태 업데이트 */
        const handleUpdateSessionData = () => {
            const permissionJSONData = JSON.stringify(userPermissionListAndIdData.value);
            hubStorage.setSessionItem({
                key: COPIED_PERMISSION_INFO,
                value: permissionJSONData,
            });
        };
        /** 세션 스토리지와의 상태 동기화 */
        const handleParseSessionData = () => {
            // 새션 탐색
            const sessionData = hubStorage.getSessionItem(COPIED_PERMISSION_INFO) || '';
            if (!sessionData) {
                return;
            }
            try {
                const parsedData = JSON
                    .parse(sessionData);
                currentCopiedPermissionList.value = parsedData.list;
                currentCopiedPermissionUserId.value = parsedData.id;
            }
            catch {
                currentCopiedPermissionList.value = [];
                currentCopiedPermissionUserId.value = '';
            }
        };
        /**
             * 권한 복사 버튼
             */
        const handleClickCopyBtn = () => {
            try {
                // 현재 권한 목록 및 Id JSON화
                handleUpdateSessionData();
                // 상태 동기화
                handleParseSessionData();
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: lc('copy_success'),
                });
            }
            catch (error) {
                console.log('handleClickCopyBtn', error);
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        /**
             * 권한 적용 버튼
             */
        const handleClickPasteBtn = () => {
            try {
                const pasteData = currentCopiedPermissionList.value
                    .map((item) => new UserPermissionSettingVM(item._raw));
                // @ts-ignore
                vuexStore.dispatch('userPermissionSettingDialog/pasteUserPermissionList', pasteData);
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: lc('paste_success'),
                });
            }
            catch (error) {
                console.log('handleClickPasteBtn', error);
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        onMounted(() => {
            handleParseSessionData();
        });
        return (_ctx, _cache) => {
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (!!userInfo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createCommentVNode(" 사용자명 "),
                    _createVNode(InputRow, {
                        label: locale.userName,
                        "is-vertical-label": "",
                        "input-row-class": ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                                class: "px-4 d-flex",
                                variant: "outlined"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, _toDisplayString(userInfo.value.validatedName), 1 /* TEXT */)
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]),
                    _createCommentVNode(" 사용자레벨 "),
                    _createVNode(InputRow, {
                        label: locale.userLevel,
                        "is-vertical-label": "",
                        "input-row-class": ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                                class: "px-4 d-flex",
                                variant: "outlined"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(userInfo.value.formattedLevel), 1 /* TEXT */)
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]),
                    _createCommentVNode(" 권한 복사 버튼 "),
                    _createVNode(_component_v_btn, {
                        class: "ml-1 align-self-end brg-btn info size-l outlined",
                        onClick: handleClickCopyBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode(" mdi-content-copy ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [0]
                            }),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(locale.copyForm), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 복사 된 아이디 (복사된 값이 있는 경우 노출) "),
                    (!isPasteDisabled.value)
                        ? (_openBlock(), _createBlock(InputRow, {
                            key: 0,
                            label: locale.copiedUserId,
                            "is-vertical-label": "",
                            "input-row-class": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                    class: "px-4 d-flex",
                                    variant: "outlined"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(currentCopiedPermissionUserId.value), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" 권한 적용 버튼 (복사된 값이 있는 경우 enable) "),
                    _createVNode(_component_v_btn, {
                        class: "align-self-end brg-btn info size-l outlined",
                        disabled: isPasteDisabled.value,
                        onClick: handleClickPasteBtn
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createTextVNode(" mdi-content-paste ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [1]
                            }),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(locale.pasteForm), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
